import { useQuery } from "@tanstack/react-query";
import {
  fetchMetaAdsAdSetDetail,
  isMetaAdsApiConfigured,
} from "./useMetaAdsApi";

/**
 * Loads a single Meta ad set for the ad set editor.
 */
export function useMetaAdsAdSetForEdit(adSetId, options = {}) {
  const { enabled = true } = options;
  const id = String(adSetId || "").trim();
  return useQuery({
    queryKey: ["meta-ads-adset-detail", id],
    queryFn: () => fetchMetaAdsAdSetDetail(id),
    enabled: Boolean(enabled && isMetaAdsApiConfigured() && id),
    staleTime: 30_000,
  });
}
